import Icon from '../../shared/Icon.tsx';
import {ImageIcon, LoaderCircleIcon, VideoIcon} from 'lucide-react';

export enum FallbackType {
    image,
    video,
    youtube
}

interface FallbackProps {
    width: number;
    height: number;
    type: FallbackType;
    isLoaded: boolean;
}

const Fallback = ({width, height, type, isLoaded}: FallbackProps) => {
    const icon = (() => {
        switch (type) {
            case FallbackType.image:
                return ImageIcon;
            case FallbackType.video:
            case FallbackType.youtube:
                return VideoIcon;
            default:
                return LoaderCircleIcon;
        }
    })();
    return (
        <div
            className={
                isLoaded
                    ? 'd-none'
                    : 'd-flex justify-content-center align-items-center'
            }
            style={{width, height, backgroundColor: '#dfdfdf'}}
        >
            <Icon fontSize={48} icon={icon} />
        </div>
    );
};

export default Fallback;
